import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => {

	return {
		gridContainer: {
			display                    : "grid",
			flexWrap                   : "wrap",
			justifyContent             : "start",
			[rooterMediaQuery.desktop] : {
				gridTemplateColumns: "repeat(5,minmax(0,1fr))"
			},
			[rooterMediaQuery.tablet]: {
				gridTemplateColumns: "repeat(3,minmax(0,1fr))"
			},
			gridTemplateColumns : "repeat(2,minmax(0,1fr))",
			rowGap              : "4rem",
			columnGap           : "2rem",
			padding             : "1rem 1rem"
		},
		overlay: {
			position     : "absolute",
			top          : "0",
			left         : "0",
			height       : "100%",
			background   : "#126bd5",
			opacity      : "0.5",
			borderRadius : "20px",
			width        : "100%"
		},
		overlayLanguage: {
			position     : "absolute",
			top          : "0",
			left         : "0",
			height       : "100%",
			background   : "#126bd5",
			opacity      : "0.5",
			borderRadius : "10px",
			width        : "100%"
		},
		nextButton: {
			opacity: ( props?.step === 1 && props?.name && props?.name.trim ().length !== 0 )
        || ( props?.step === 2 && props?.locale ) || ( props?.step === 3 && props?.selectedGames?.length > 0 ) || props?.step === 4 ? 1 : 0.7
		},
		bottomSection: {
			// minHeight      : "5rem",
			bottom         : "0",
			position       : "sticky",
			display        : "flex",
			alignItems     : "center",
			justifyContent : props?.step === 4 || props?.fromUserSettings ? "right" : "space-between",
			padding        : "1rem 2rem"
		},
		btn: {
			padding: "0.8rem 2rem"
		},
		btnLabel: {
			fontWeight: "500"
		},
		backButton: {
			padding         : "0",
			color           : "#126bd5",
			fontSize        : "13px",
			textTransform   : "none",
			fontWeight      : "500",
			minWidth        : "min-content",
			marginRight     : "2rem",
			backgroundColor : "transparent !important"
		},
		topHeader: {
			minHeight      : "5rem",
			display        : "flex",
			alignItems     : "center",
			justifyContent : "left",
			borderBottom   : theme.other.darkMode ? "none" : `solid 1px ${ theme.other.colors.border.primary }`,
			position       : "relative"
		},
		settingsText: {
			marginLeft : "2rem !important",
			fontWeight : "500",
			fontSize   : "1.5rem"
		},
		settingsHeader: {
			marginLeft : "2rem !important",
			fontSize   : "1.3rem",
			color      : "#126bd5"
		},
		crossButton: {
			position  : "absolute",
			right     : "10px",
			cursor    : "pointer",
			transform : "scale(0.7)",
			width     : "3rem"
		},
		crossButtonInvert: {
			position  : "absolute",
			right     : "10px",
			cursor    : "pointer",
			transform : "scale(0.7)",
			filter    : "invert(1)",
			width     : "3rem"
		},
		inputLabelandContentWrapper: {
			display       : "flex",
			flexDirection : "column",
			marginBottom  : "20px"
		},
		inputWrapper: {
			width: "100%"
		},
		iconBottomMargin: {
			marginBottom: "0.5rem"
		},
		inputContent: {
			margin          : 0,
			padding         : "10px",
			backgroundColor : "#0000001a",
			border          : "none",
			outline         : "none",
			userSelect      : "none",
			width           : "100%",
			borderRadius    : "5px",
			color           : "#000000",
			caretColor      : theme.other.paletteNew.primaryDarkBlue,

			"&:focus": {
				border: `solid 1px ${ theme.other.paletteNew.primaryDarkBlue }`
			},

			"&.error": {
				border: "solid 1px red !important"
			},
			"&::placeholder": {
				color      : "#757575",
				fontSize   : "1.3rem",
				fontWeight : "normal"
			}
		},
		errorUrl: {
			marginTop : "5px",
			color     : "red",
			fontSize  : "13px"
		},
		mobileNumber: {
			margin          : 0,
			display         : "flex",
			padding         : "10px",
			fontSize        : "1.3rem",
			backgroundColor : "#0000001a",
			border          : "none",
			outline         : "none",
			userSelect      : "none",
			width           : "100%",
			borderRadius    : "5px"
		},
		labelInput: {
			display      : "flex",
			alignItems   : "center",
			width        : "135px",
			fontSize     : "1.4rem",
			fontWeight   : "500",
			marginBottom : "0.5rem"
		},
		labelInputTag: {
			display    : "flex",
			alignItems : "center",
			width      : "135px",
			fontSize   : "1.4rem",
			fontWeight : "500"
		},
		verifiedMobileTick: {
			marginLeft: "5px"
		},
		handleIcon: {
			height      : "22px",
			width       : "22px",
			marginRight : "0.8rem"
		},
		button: {
			border    : "1px solid #ffffff",
			"&:hover" : {
				border     : "1px solid #fefefe",
				background : "rgb(0 0 0 / 80%)"
			},
			background: "rgb(0 0 0 / 50%)"
		},
		customDialog: {
			maxHeight       : "calc(100% - 40px)",
			borderRadius    : "15px",
			backgroundColor : theme.other.colors.dialog.primary,
			flex            : "0 0 auto"
		},
		modalContent: {
			display         : "flex",
			justifyContentL : "center",
			overflow        : "auto",
			backgroundColor : theme.other.colors.dialog.secondary,
			maxHeight       : "50vh"
		},
		modalBody: {
			display       : "flex",
			flexDirection : "column",
			padding       : "0",
			overflow      : "hidden"
		},
		textAreaInput: {
			padding         : "1rem",
			backgroundColor : "#0000001a",
			border          : "none",
			outline         : "none",
			userSelect      : "none",
			width           : "100%",
			minHeight       : "10rem",
			borderRadius    : "5px",
			resize          : "none",
			fontFamily      : "inherit",
			caretColor      : "#126bd5",
			"&:focus"       : {
				border: "solid 1px #126bd5"
			},
			"&::placeholder": {
				color      : "#757575",
				fontSize   : "1.3rem",
				fontWeight : "normal"
			}
		},
		userAvatar: {
			display        : "flex",
			flexDirection  : "column",
			justifyContent : "center",
			alignItems     : "center",
			marginBottom   : "25px"
		},
		photo: {
			height       : "100%",
			borderRadius : "50%",
			position     : "absolute"
		},
		genderDropdown: {
			width      : "100%",
			fontSize   : "14px",
			fontWeight : "500",
			color      : "#000000"
		},
		headingWrapper: {
			display        : "flex",
			flexDirection  : "row",
			background     : "#f0f0f0",
			height         : "1px",
			marginTop      : "25px",
			marginBottom   : "22px",
			justifyContent : "center",
			position       : "relative"
		},
		heading: {
			fontSize     : "13px",
			fontWeight   : "500",
			background   : "white",
			paddingLeft  : "10px",
			paddingRight : "10px",
			position     : "absolute",
			top          : "-8px"
		},
		saveButton: {

			height        : "30px",
			background    : theme.other.paletteNew.mainGradient,
			textTransform : "none !important",
			boxShadow     : "none !important",
			borderRadius  : "10px",
			padding       : "1.7rem 1.5rem"
		},
		avatarContainer: {
			margin   : "0 0.8rem 1.5rem 0.8rem",
			display  : "flex",
			position : "relative"
			// maxHeight : "7rem"
		},
		actorAvatar: {
			width     : "80px",
			height    : "80px",
			objectFit : "contain",
			border    : "0.5px solid black",
			position  : "relative",
			...theme.other.rooterAvatars.borderRadius
		},
		saveButtonContainer: {
			padding: "0.5rem 1.5rem"
		},
		coinsSvg: {
			width      : "2rem",
			marginLeft : "0.2rem"
		},
		nameText: {
			fontWeight   : "500",
			marginBottom : "0.5rem"
		},
		progressContainer: {
			display      : "flex",
			alignItems   : "center",
			marginBottom : "1rem"
		},
		coinsContainer: {
			display    : "flex",
			alignItems : "center",
			fontWeight : "500",
			fontSize   : "1.3rem",
			marginLeft : "1rem"
		},
		completedCoinsContainer: {
			display    : "flex",
			alignItems : "center",
			margin     : "1rem 0 6rem 0"
		},
		infoIcon: {
			width: "4rem"
		},
		informationContainer: {
			display    : "flex",
			// flexDirection : "column",
			alignItems : "center"
		},
		completeOnboardContainer: {
			display       : "flex",
			flexDirection : "column",
			alignItems    : "center"
		},
		completedCoins: {
			width       : "2rem",
			marginRight : "1rem"
		},
		gameName: {
			textAlign  : "center",
			fontWeight : "500",
			whiteSpace : "nowrap",
			marginTop  : "0.8rem",
			position   : "absolute",
			top        : "9.5rem",
			left       : "1rem",
			fontSize   : "1.2rem"
		},
		gameNameLeftPositioned: {
			textAlign  : "center",
			fontSize   : "1.2rem",
			fontWeight : "500",
			whiteSpace : "nowrap",
			marginTop  : "0.8rem",
			position   : "absolute",
			top        : "9.5rem",
			left       : "2.5rem"
		},
		shortNameLeftPositioned: {
			textAlign  : "center",
			fontSize   : "1.2rem",
			fontWeight : "500",
			whiteSpace : "nowrap",
			marginTop  : "0.8rem",
			position   : "absolute",
			top        : "9.5rem",
			left       : "3.5rem"
		},
		completedIcon: {
			margin : "1.5rem 0",
			width  : "6rem"
		},
		selectedGame: {
			position       : "absolute",
			top            : "8px",
			right          : "8px",
			color          : "#126bd5",
			fontWeight     : "500",
			borderRadius   : "50%",
			width          : "25px",
			height         : "25px",
			// padding      : "2px",
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center",
			background     : "#fff",
			border         : "2px solid #126bd5",
			textAlign      : "center",
			zIndex         : 1,
			margin         : "0"
		},
		gameImage: {
			width        : "90px",
			height       : "90px",
			display      : "block",
			borderRadius : "20px"
		},
		languageImage: {
			display: "block"
		},
		languageSelected: {
			display : "block",
			filter  : "brightness(0.7)"
		},
		root: {
			width        : "100%",
			borderRadius : "1rem",
			fontSize     : "1.6rem",
			caretColor   : theme.other.paletteNew.primaryDarkBlue,

			"& input": {
				color: theme.other.colors.text.primary,

				"&::placeholder": {
					color: theme.other.colors.text.primary
				}
			}

		},
		searchBarContainer: {
			"& .MuiOutlinedInput-root": {
				paddingLeft  : "8px",
				"& fieldset" : {
					borderRadius : "30px",
					zIndex       : "-1",
					border       : "none"
				}
			},
			"&$cssFocused $notchedOutline": {
				borderColor: "#126bd5 !important"

			}
		},
		cssFocused: {
			borderColor: "#126bd5 !important"
		},
		notchedOutline: {
			borderRadius : "10px !important",
			borderColor  : "#e7e7e7 !important"
		},
		contentContainer: {
			backgroundColor: theme.other.colors.dialog.secondary
		},
		label: {
			fontSize  : "1.6rem",
			"&:focus" : {
				borderColor: "transparent"
			},
			"&:focus-within": {
				borderColor: "transparent"
			}
		},
		languageGrid: {
			display                   : "grid",
			[rooterMediaQuery.mobile] : {
				gridTemplateColumns: "repeat(2, 1fr) !important"
			},
			gridTemplateColumns: "repeat(3, 1fr)"
		}
	};
} );
